module.exports = __webpack_public_path__ + "static/media/info-information.79240150.png";